var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('background-color:' + _vm.backgroundColor + '; color:' + _vm.color),attrs:{"id":"wrapper"}},[_vm._v(" Térkitöltő szöveg ")])}
var staticRenderFns = []

export { render, staticRenderFns }